import { ISSUE_CONSTANT } from '../constants/IssueConstants';
import properties from 'properties';
import AppUtil from 'js/utils/AppUtil';
import { GLOBAL_CONSTANTS, APP_URL_CONSTANTS } from 'js/common/constants/GlobalConstants';
import { addIssueCollectorInListing, changeHomePage, updateICInListing } from 'js/app/actions/AppActions';
import AppHelper from 'js/app/AppHelper';
import isFeatureEnable from 'js/utils/FeatureUtil';

export const populateIssueConfigData = data => {
    return {
        type: ISSUE_CONSTANT.LOAD_ISSUE_CONFIG,
        payload: {
            data
        }
    }
}

export const updateIssueCollectorConfig = config => {
    return {
        type: ISSUE_CONSTANT.UPDATE_ISSUE_COLLECTOR_CONFIG,
        config
    }
}

export const populateCustomFields = customFields => {
    return {
        type: ISSUE_CONSTANT.POPULATE_CUSTOM_FIELDS,
        customFields
    }
}

 /* istanbul ignore next */
export const synchCustomFields = (dbSavedCustomFields, newCustomFields, collectorId, openFrom) => {
    return dispatch => {
        let isDataChanged = false;
        const synchedCustomFields = [];

        dbSavedCustomFields.forEach( dbfield => {
            let w_newFieldData = newCustomFields.filter( field => field.fieldName === dbfield.fieldName );

            if ( w_newFieldData.length > 0 ) {
                w_newFieldData = w_newFieldData[0];

                if ( dbfield.fieldLabel !== w_newFieldData.fieldLabel ) {
                    isDataChanged = true;
                    dbfield.fieldLabel = w_newFieldData.fieldLabel;
                } 
                
                if ( dbfield.maxCharLimit !== w_newFieldData.maxCharLimit ) {
                    isDataChanged = true;
                    dbfield.maxCharLimit = w_newFieldData.maxCharLimit;
                } 
                
                if ( dbfield.valueList && JSON.stringify(dbfield.valueList) !== JSON.stringify(w_newFieldData.valueList) ) {
                    isDataChanged = true;
                    dbfield.valueList = w_newFieldData.valueList;
                }

                synchedCustomFields.push(dbfield);
            } else {
                isDataChanged = true;
            }
        })

        if ( isDataChanged ) {
            dispatch( populateCustomFields(synchedCustomFields) );

            if (openFrom !== "outside") {
                dispatch( updateICInListing({
                    id: collectorId,
                    customFields: synchedCustomFields
                }) );
            }
            
            const url = properties.url + APP_URL_CONSTANTS.UPDATE_COLLECTOR_CUSTOM_FIELDS + collectorId + 
            "/" + AppHelper.getParamData('sologinid');

            AppUtil.ajax(url, synchedCustomFields, undefined, undefined, undefined, undefined, false);
        }
    }
}

export const updateDescriptionControlType = controlType => {
    return {
        type: ISSUE_CONSTANT.UPDATE_DESCRIPTION_CONTROL_TYPE,
        controlType
    }
}

 /* istanbul ignore next */
export const getCustomFields = (itemType, customFields, isSynchCustomFields, collectorId, openFrom) => {
    return dispatch => {
        let projectId= AppHelper.getParamData('sointprjid')

        if (openFrom === "outside") {
            projectId = AppHelper.getAppData("project").source_projectid
        }
        const url = properties.url + APP_URL_CONSTANTS.GET_CARD_CUSTOM_FIELDS_URL + "/" + AppHelper.getParamData('icentid') +
            "/" + projectId + "/" + itemType + "/" + AppHelper.getParamData('sologinid');

        AppUtil.ajax(url, undefined, response => {
            const descriptionField = response.filter( field => field.isDescriptionField );
            response = response.filter( field => !field.isDescriptionField ).map( field => {
                delete field.isDescriptionField;
                return field;
            })

            if ( descriptionField.length > 0 && descriptionField[0].controlType === GLOBAL_CONSTANTS.REACH_TEXTBOX ) {
                dispatch( updateDescriptionControlType( "RTF" ) );
            } else {
                dispatch( updateDescriptionControlType( undefined ) );
            }

            if ( customFields ) {
                response = response.map( field => {
                    const savedField = customFields.filter( item => item.fieldName === field.fieldName )

                    if ( savedField.length > 0 ) {
                        return {
                            ...field,
                            order: savedField[0].order,
                            selectedType: savedField[0].selectedType
                        }
                    } else {
                        return field;
                    }
                })
            }

            if ( isSynchCustomFields ) {
                dispatch( synchCustomFields(customFields, response, collectorId, openFrom) )
            }
            if (openFrom !== "outside") {
                dispatch( populateCustomFields(response) );
            }
        });
    }
}

 /* istanbul ignore next */
export const loadIssueConfig = ( customFields, isSynchCustomFields, collectorId, savedCardType ) => {
    return dispatch => {
        let cardTypes = AppHelper.getAppData( 'card_type_list' ) || [];

        cardTypes = cardTypes.sort((a, b) => a.cardTypeName.localeCompare(b.cardTypeName)).filter( cardType => cardType.isSelected );
        
        dispatch( getCustomFields(savedCardType || cardTypes[0].cardType, customFields, isSynchCustomFields, collectorId) )
    }
}

export const setFormDirtyFlag = isDirty => {
    return {
        type: ISSUE_CONSTANT.SET_FROM_DRITY_FLAG,
        isDirty
    }
}

 /* istanbul ignore next */
export const saveIssueController = ( config, customFields ) => {
    return dispatch => {
        const url = properties.url + APP_URL_CONSTANTS.CREATE_ISSUE_COLLECTOR_URL + "/" + AppHelper.getParamData('sologinid');

        AppUtil.ajax(url, config, response => {
            response.customFields = customFields;

            if ( !config.id ) {
                dispatch( changeHomePage(GLOBAL_CONSTANTS.ISSUE_COLLECTOR_CONGRATS) );
                dispatch( addIssueCollectorInListing(response) );
            } else {
                dispatch( updateICInListing(response) );
            }

            dispatch( updateIssueCollectorConfig(response) );
            dispatch( setFormDirtyFlag(false) );
        });
    }
}

export const changeIcCardType = cardCode => {
    return {
        type: ISSUE_CONSTANT.CHANGE_IC_CARD_TYPE,
        cardCode
    }
}

export const changeIcDes = description => {
    return {
        type: ISSUE_CONSTANT.CHANGE_IC_DESC,
        description
    }
}

export const changeIcAllowedEmails = emails => {
    return {
        type: ISSUE_CONSTANT.CHANGE_ALLOWED_EMAIL_IDS,
        emails
    }
}

export const changeIcPos = position => {
    return {
        type: ISSUE_CONSTANT.CHANGE_IC_POS,
        position
    }
}

export const changeScreenTitle = screentitle => {
    return {
        type: ISSUE_CONSTANT.CHANGE_SCREEN_TITLE,
        screentitle
    }
}

export const changeIntroductionText = introductiontext => {
    return {
        type: ISSUE_CONSTANT.CHANGE_INTRODUCTION_TEXT,
        introductiontext
    }
}

export const changeIssueTitle = issuetitle => {
    return {
        type: ISSUE_CONSTANT.CHANGE_ISSUE_TITLE,
        issuetitle
    }
}

export const changeDescriptionTitle = descriptiontitle => {
    return {
        type: ISSUE_CONSTANT.CHANGE_DESCRIPTION_TITLE,
        descriptiontitle
    }
}

export const isAttachmentAvailable = isavailable => {
    return {
        type: ISSUE_CONSTANT.IS_ATTACHMENT_AVAILABLE,
        isavailable
    }
}

export const changeTriggerFontColor = color => {
    return {
        type: ISSUE_CONSTANT.CHANGE_TRIGGER_FONT_COLOR,
        color
    }
}

export const changeTriggerBgColor = color => {
    return {
        type: ISSUE_CONSTANT.CHANGE_TRIGGER_BG_COLOR,
        color
    }
}

export const changeTriggerText = triggertext => {
    return {
        type: ISSUE_CONSTANT.CHANGE_TRIGGER_TEXT,
        triggertext
    }
}

export const emptyICConfig = () => {
    return {
        type: ISSUE_CONSTANT.EMPTY_ISSUE_COLLECTOR_CONFIG
    }
}

export const resetIC = config => {
    return {
        type: ISSUE_CONSTANT.RESET_ISSUE_CONFIG,
        config
    }
}

 /* istanbul ignore next */
export const resetIssueConfig = (id, customFields) => {
    return dispatch => {
        const url = properties.url + APP_URL_CONSTANTS.RESET_ISSUE_CONFIG_URL + '/' + id + '/' + AppHelper.getAppData('projectId') +
        "/" + AppHelper.getParamData('sologinid');

        AppUtil.ajax(url, undefined, response => {

            if ( response.issueCollector.customFields ) {
                response.issueCollector.customFields = customFields.map( field => {
                    const savedField = response.issueCollector.customFields.filter( item => item.fieldName === field.fieldName )

                    if ( savedField.length > 0 ) {
                        return {
                            ...field,
                            ...savedField[0]
                        }
                    } else {
                        return {
                            ...field,
                            selectedType: undefined
                        };
                    }
                })
            }

            dispatch( resetIC(response.issueCollector) );
            dispatch( setFormDirtyFlag(false) );
        }, undefined, undefined, undefined, false);
    }
}

 /* istanbul ignore next */
export const getIssueCollectorData = (collectorData, callbackFun) => {
    return dispatch => {
       const url = properties.url + APP_URL_CONSTANTS.GET_ISSUE_COLLECTOR_BY_ID + "/" + collectorData.collectorid + "/" + 
       collectorData.projectid + "/" + AppHelper.getParamData('sologinid');
    
       AppUtil.ajax(url, undefined, result => {
            AppHelper.initConfig( result );
            AppHelper.addInParamMap({
                currentbuildversion: result.sourceVersionNumber
            });
            AppHelper.addInConfigMap({
                enterpriseType: result.enterprise.enterprisetype
            });

            if ( isFeatureEnable('attachmentSourceSize') ) {
                const sourcePropertyDataURL = properties.url + APP_URL_CONSTANTS.GET_SOURCE_PROPERTIES_URL + '/' + result.enterprise.id
                    + '/' + AppHelper.getParamData('sologinid');

                AppUtil.ajax(sourcePropertyDataURL, undefined, response => {
                    AppHelper.addInConfigMap({
                        sourceProperties: response
                    });

                    dispatch( populateIssueConfigData(result.issueCollector) );

                    callbackFun();
                })
            } else {
                AppHelper.addInConfigMap({
                    sourceProperties: {
                        attachmentSize: 512
                    }
                });

                dispatch( populateIssueConfigData(result.issueCollector) );

                callbackFun();
            }

       }, () => {
            dispatch(populateIssueConfigData({status: "disabled"}));
       });
     }
}

export const setCustomFieldSelection = ( fieldName, selectedType ) => {
    return {
        type: ISSUE_CONSTANT.SET_FIELD_SELECTION,
        fieldName,
        selectedType
    }
}

export const reOrderCustomField = (fieldName, order, selectedType) => {
    return {
        type: ISSUE_CONSTANT.REORDER_CUSTOM_FIELD,
        fieldName,
        order,
        selectedType
    }
}